import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "16",
      height: "16",
      fill: "#215f69",
      rx: "4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M6.58 11c-.2 0-.39-.078-.531-.215L3.218 8.021a.724.724 0 0 1 0-1.035.77.77 0 0 1 1.06 0L6.58 9.232l5.143-5.02a.77.77 0 0 1 1.06 0c.29.284.29.752 0 1.036L7.11 10.785a.76.76 0 0 1-.53.215"
    }, null, -1)
  ]))]))
}
export default { render: render }